import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: "alert",
    class: _normalizeClass({dismiss: !$setup.aggressive})
  }, [
    _createElementVNode("div", null, [
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "warn" }, "⚠", -1)),
      _createElementVNode("button", {
        class: "secondary button-close close",
        onClick: $setup.dismiss
      }, _cache[0] || (_cache[0] = [
        _createElementVNode("svg", {
          class: "icon chevron chevron-down",
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          _createElementVNode("path", {
            class: "fill",
            d: "M16.59 8.59L12 13.17L7.41 8.59L6 10L12 16L18 10L16.59 8.59Z"
          })
        ], -1)
      ])),
      _cache[2] || (_cache[2] = _createElementVNode("p", null, "Main Calendar is not set up", -1)),
      _cache[3] || (_cache[3] = _createElementVNode("p", null, "Events Scheduling, Contracts, and Invoices need a set Main Calendar to function", -1))
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.mainCalendar, (j, i) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: `i-${i}`
      }, [], 64))
    }), 128))
  ], 2))
}